import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/components/ui/sheet';

/**
 * Universal History / audit slide-out.
 *
 * Founder lock (31 Aug 2026): every new History or audit UI uses this
 * right Sheet — the Estimate Audit Trail chrome. Do not invent a modal,
 * full page, or a second visual language.
 *
 * Source of truth: AuditTrailSidebar (Sheet + SheetContent, right-side
 * drawer, primary header, Close, card body).
 */
export const HISTORY_AUDIT_SHEET_CONTENT_CLASS =
  '!w-full sm:!w-[450px] !max-w-full sm:!max-w-[450px] p-0 bg-primary';

export function HistoryAuditSheet({
  open,
  onOpenChange,
  title,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className={HISTORY_AUDIT_SHEET_CONTENT_CLASS}>
        <div className="flex h-full flex-col">
          <div className="bg-primary p-6 pb-4">
            <div className="flex items-center justify-between gap-3">
              <SheetTitle className="text-xl font-bold tracking-tight text-primary-foreground">
                {title}
              </SheetTitle>
              <Button
                type="button"
                variant="secondary"
                size="sm"
                onClick={() => onOpenChange(false)}
                className="shrink-0"
              >
                Close
              </Button>
            </div>
            <SheetDescription className="sr-only">
              History and audit events, newest first.
            </SheetDescription>
          </div>
          <div className="flex-1 overflow-y-auto bg-card p-4">{children}</div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
